import {WechatInitOptions} from "../base/options";

/**
 * 企业微信 服务
 */
export class WechatService {

  static wechatOptions: WechatInitOptions;

  /**
   * 初始化
   */
  static async init(options: WechatInitOptions): Promise<void> {
    WechatService.wechatOptions = options;

    WechatService.wechatOptions.corp.apiUrl = options.corp.apiUrl || "https://qyapi.weixin.qq.com/cgi-bin/";
  }

  /**
   * 获取企业微信设置
   */
  static async getWechatOptions(): Promise<WechatInitOptions> {
    return WechatService.wechatOptions;
  }

}
